module.exports = global["pdfMake"] = require("-!d:\\pdfmake\\_ke smazani\\pdfmake02\\node_modules\\babel-loader\\lib\\index.js??ref--4!.\\pdfMake.js");